import classNames from "classnames";

export const container = classNames(
    // "mobile:h-max"
    "mobile:bg-[url(/assets/images/backgrounds/awards/x-mobile.svg)]",
    "mobile:bg-left",
    "mobile:bg-no-repeat",
    "mobile:bg-[position:5px_-60px]",
    "mobile:p-4",
    // "mobile:-translate-y-6",
    // Tablet
    "tablet:bg-[url(/assets/images/backgrounds/awards/x-desktop.svg)]",
    "tablet:bg-left-top",
    "tablet:bg-no-repeat",
    "tablet:bg-[position:18px_3px]",
    "tablet:p-[4.2rem]",
    "tablet:h-max",
    "tablet:mt-4",
    "tablet:relative",
    // All
    "flex",
    "items-center",
    "justify-center",
)

export const heading = classNames(
    // Mobile
    // Tablet
    // All
    "flex",
    "flex-col",
    "justify-center",
    "items-center",
);

export const subheading = classNames(
    // Mobile
    "mobile:text-lg",
    "mobile:text-center",
    "mobile:mt-2",
    "mobile:mx-6",
    "mobile:pt-2",
    // Tablet
    "tablet:text-2xl",
    "tablet:mt-6",
    "tablet:w-9/12",
    // All
)
